import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { ProductCarousel } from "../../../../components/ProductCarousel";
import { useConsumablesProductDetailsContext } from "../../../../providers/ConsumablesProductDetailsProvider";
import { getFilteredImagesByRole } from "../../../../utils/getFilteredImagesByRole";
export const ConsumablesProductCarousel = () => {
    const { currentMatrixItem } = useConsumablesProductDetailsContext();
    const productGalleryItems = useMemo(() => {
        const mediaGallery = currentMatrixItem.product.mediaGallery;
        const computedProductGalleryItems = mediaGallery.map(({ url, ...item }) => ({
            ...item,
            path: url,
        }));
        return getFilteredImagesByRole(computedProductGalleryItems, "dynamic_picture_bundle");
    }, [currentMatrixItem.sku, currentMatrixItem.product.mediaGallery]);
    return _jsx(ProductCarousel, { items: productGalleryItems }, currentMatrixItem.sku);
};
//# sourceMappingURL=ConsumablesProductCarousel.js.map